/**
 * LinkedIn URL normalisation.
 *
 * Copied verbatim from the Add Linkedin Url modal
 * (components/Modals/workstation/BulkAddLinkedinUrl.jsx) so the Excel import
 * sends exactly the same shape of URL the manual form does. That file and
 * view/lead_dashboard/components/AddContacts.jsx still hold their own copies -
 * they are working and were left alone deliberately.
 *
 * Anything that is not a /in/<slug> profile comes back as "". That is what
 * keeps company pages (/company/...) out of a candidate import.
 *
 * Note the bare-username branch: a value with no "linkedin.com" in it is taken
 * to be a slug. That is right for a form a human typed into, but wrong for a
 * spreadsheet cell holding free text such as "No poach list". Callers reading
 * a file must check the raw value contains "linkedin.com" before calling this -
 * see isProfileUrlText below.
 */

/**
 * Is this spreadsheet cell worth handing to normalizeLinkedInUrl?
 *
 * Deliberately strict: the value must name linkedin.com itself. Bare slugs are
 * not accepted from a file, because a free-text comment cannot be told apart
 * from a username.
 */
export const isProfileUrlText = (value) =>
  typeof value === "string" && /linkedin\.com/i.test(value);
export const normalizeLinkedInUrl = (input) => {
  if (!input) return "";

  let url = String(input).trim();

  // If only username is entered
  if (!url.includes("linkedin.com")) {
    return `https://www.linkedin.com/in/${url.replace(/^\/+|\/+$/g, "")}/`;
  }

  // Ensure protocol
  if (!/^https?:\/\//i.test(url)) {
    url = "https://" + url;
  }

  try {
    const parsed = new URL(url);

    // Remove subdomains like in.linkedin.com, uk.linkedin.com
    parsed.hostname = "www.linkedin.com";

    // Remove query params and hash
    parsed.search = "";
    parsed.hash = "";

    const pathParts = parsed.pathname.split("/").filter(Boolean);

    if (pathParts[0] === "in" && pathParts[1]) {
      return `https://www.linkedin.com/in/${pathParts[1]}/`;
    }

    return "";
  } catch {
    return "";
  }
};

export default normalizeLinkedInUrl;
